export default __webpack_public_path__ + "static/media/xopa_cloudxier2.37f9c57d.png";